import { message } from "antd";
import CallerIdSettings from "./CallerIdSettings";
import { useEffect, useState } from "react";
import HButton from "../../../components/custom/input/button/Button";
import { useVoiceNumbers } from "../../hooks/useVoiceNumbers";
import DepartmentId from "./DepartmentId";

const VoiceConfiguration = (props) => {
  const {
    phoneNumber,
    setPhoneConfigurationSettingPage,
    selectedNumberData,
    setSavedNumbers,
    departmentsList,
  } = props;

  const [voiceConfigurations, setVoiceConfigurations] = useState({
    callerId: "",
    outgoingCallerIdSid: "",
    userSpecific: false,
    teamId: "",
    userId: "",
    phoneNumber: "",
    departmentId: "",
    selectedTeamId: "",
    selectedUserId: "",
  });
  
  const { updateVoiceConfiguration } = useVoiceNumbers();

  useEffect(() => {
    if (selectedNumberData) {
      setVoiceConfigurations((prev) => ({
        ...prev,
        callerId: selectedNumberData.callerId || prev.callerId,
        outgoingCallerIdSid: selectedNumberData.outgoingCallerIdSid || prev.outgoingCallerIdSid,
        departmentId: selectedNumberData.departmentId || prev.departmentId,
      }));
    }
  }, [selectedNumberData]);
  

  const handleSaveCallerId = async () => {
    if (voiceConfigurations?.callerId || voiceConfigurations?.departmentId) {
      const callerId = voiceConfigurations?.callerId === "none" ? "" : voiceConfigurations?.callerId;
      const payload = {
        phoneNumber: phoneNumber,
        callerId: callerId,
        outgoingCallerIdSid: voiceConfigurations?.outgoingCallerIdSid,
        userSpecific: voiceConfigurations?.userSpecific,
        teamId: voiceConfigurations?.selectedTeamId,
        userId: voiceConfigurations?.selectedUserId,
        departmentId: voiceConfigurations?.departmentId || selectedNumberData?.departmentId,
      };
      const response = await updateVoiceConfiguration(payload);
      if (response) {
        message.success("Saved successfully!");
         if (setSavedNumbers) {
          setSavedNumbers((prev) => {
            const updatedNumbers = prev?.map((number) => {
              if (number?.phoneNumber === phoneNumber) {
                return {
                  ...number,
                  callerId: callerId,
                  outgoingCallerIdSid: voiceConfigurations?.outgoingCallerIdSid,
                  departmentId: voiceConfigurations?.departmentId || selectedNumberData?.departmentId,
                };
              }
              return number;
            });
            return updatedNumbers;
          });
        }
        if (setPhoneConfigurationSettingPage) {
          setPhoneConfigurationSettingPage(false);
        }
      } else {
        message.error("Failed to save caller ID.");
      }
    } else {
      message.error("Please select a caller ID or department and try again.");
    }
  };

  return (
    <div className="p-3 gap-4 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center pb-3 hs-border-dark-grey-bottom">
        <div className="hs-fw-500 hs-fs-15">Outbound Settings for {phoneNumber}</div>
          <div className="actionIconsSprite modalCloseIcon" onClick={() => setPhoneConfigurationSettingPage(false)} />
        </div>
        <CallerIdSettings
          userSpecific={voiceConfigurations?.userSpecific}
          callerId={voiceConfigurations?.callerId}
          setCallerId={(callerId) => {
            setVoiceConfigurations((prev) => ({ ...prev, callerId: callerId }));
          }}
          outgoingCallerIdSid={voiceConfigurations?.outgoingCallerIdSid}
          setOutgoingCallerIdSid={(outgoingCallerIdSid) => {
            setVoiceConfigurations((prev) => ({ ...prev, outgoingCallerIdSid: outgoingCallerIdSid }));
          }}
          
          phoneNumber={phoneNumber}
          selectedNumberData={selectedNumberData}
          setSavedNumbers={setSavedNumbers}
        />
        <DepartmentId
          departmentsList={departmentsList}
          departmentId={voiceConfigurations?.departmentId}
          setDepartmentId={(departmentId) => {
            setVoiceConfigurations((prev) => ({ ...prev, departmentId: departmentId }));
          }}
          selectedNumberData={selectedNumberData}
        />
        <div>
          <HButton size="s" buttonClassName="w-25" onClick={handleSaveCallerId}>
            Save
          </HButton>
        </div>
    </div>
  );
};

export default VoiceConfiguration;
